import { WeatherServiceParams } from '../types/weather';
import { openmeteoParameters, xweatherParameters } from '../constants/parameters';

export function validateWeatherParams(params: WeatherServiceParams): void {
  if (!params) {
    throw new Error('Weather parameters are required');
  }

  // Skip map validation for drought model
  if (params.model !== 'drought') {
    if (!params.mapInstance || !params.drawInstance) {
      throw new Error('Map and draw instances are required');
    }

    const data = params.drawInstance.getAll();
    if (!data?.features?.length || !data.features.some(f => f.geometry.type === 'Polygon')) {
      throw new Error('Please draw at least one polygon on the map');
    }
  }

  if (!params.model) {
    throw new Error('Weather model is required');
  }

  // Skip date validation for drought data
  if (params.model !== 'drought') {
    if (!params.startDate || !params.endDate) {
      throw new Error('Start date and end date are required');
    }
  }

  // Skip parameter validation for special models
  if (params.model === 'drought') {
    if (!params.selectedState) {
      throw new Error('Please select a state to view drought data');
    }
    return;
  }

  if (!params.parameter) {
    throw new Error('Weather parameter is required');
  }

  // Validate parameter is supported by selected model
  const validParameters = params.model === 'xweather' 
    ? Object.values(xweatherParameters)
    : Object.values(openmeteoParameters);

  if (!validParameters.includes(params.parameter)) {
    throw new Error(`Parameter "${params.parameter}" is not supported by the selected model`);
  }

  // Validate storm-specific parameters
  if (params.model === 'xweather' && params.parameter === 'storm_reports') {
    if (typeof params.stormFilter !== 'string') {
      throw new Error('Storm filter is required for storm reports');
    }
    if (params.stormFilter === 'hail' && typeof params.hailThreshold !== 'number') {
      throw new Error('Hail threshold is required for hail reports');
    }
  }
}